'use client'

import cn from 'clsx'
import s from './animated-arrow.module.css'

/**
 * AnimatedArrow component that displays an arrow with hover animation
 * @param {Object} props - Component props
 * @param {string} [props.className] - Additional class name for the component
 * @param {string} [props.firstColor] - Color for the first arrow (default: inherit)
 * @param {string} [props.secondColor] - Color for the second arrow (default: #e30613)
 * @param {string} [props.arrowSymbol] - Symbol to use for the arrow (default: →)
 * @param {boolean} [props.showSecondDesktopOnly] - Whether to show the second arrow only on desktop
 * @returns {JSX.Element} AnimatedArrow component
 */
export function AnimatedArrow({
  className,
  firstColor = 'inherit',
  // secondColor = '#e30613',
  arrowSymbol = '→',
  showSecondDesktopOnly = true,
}) {
  return (
    <span className={cn(s.arrow, className)}>
      <span
        className={s.first}
        style={{ color: firstColor }}
      >
        {arrowSymbol}
      </span>
      <span
        className={cn(s.second, showSecondDesktopOnly && 'desktop-only')}
        // style={{ color: secondColor }}
      >
        {arrowSymbol}
      </span>
    </span>
  )
}
